import { ringBells } from './ring-bells';

export const notifyControl = () => {
  if (typeof window.navigator.vibrate !== 'undefined') {
    window.navigator.vibrate([100, 100, 100]);
  }
  ringBells();
}
